import { useState } from "react";
import "../css/RadioButton.css";
import { inputOnEnter } from "../js/utils";

export default function RadioButton({ active, tabIndex, onClick = () => {} }) {
  const [isInputFocused, setIsInputFocused] = useState(false);

  const handleKeyUp = (event) => {
    if (event.key === " ") {
      onClick();
    } else {
      inputOnEnter(event);
    }
  };

  const handleInputFocus = () => {
    setIsInputFocused(true);
  };

  const handleInputBlur = () => {
    setIsInputFocused(false);
  };

  return (
    <div
      className={`radio-button-content ${
        active ? "radio-button-content-on" : "radio-button-content-off"
      }`}
    >
      <button
        className={`radio-button-container
        ${active ? "radio-button-selected" : ""} ${
          isInputFocused ? "radio-op-focused" : ""
        }`}
        onClick={() => {
          onClick();
        }}
      >
        <input
          type="radio"
          className="radio-button-input"
          tabIndex={tabIndex}
          onKeyUp={handleKeyUp}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
        ></input>
      </button>
    </div>
  );
}
